import moment from "moment";
import {
  DATA_PASSAT_NO_MOSTRAR_SELECTOR_OBSERVACIONS,
  DATA_PASSAT_NO_MOSTRAR_SELECTOR_OBSERVACIONS_ADMIN
} from "../constantsObservacions.js";

export const MASCARA_DDMMYYYY = "DD-MM-YYYY";
export const MASCARA_YYYYMMDD = "YYYY-MM-DD";
export const MASCARA_ISO_DIA = "YYYY-MM-DD";
export const MASCARA_ISO_HORA = "T12:00Z";
export const MASCARA_ISO_HHMM_Z = "YYYY-MM-DDTHH:mmZ";

export const esDiaFutur = primeraData => {
  const dataActual = moment();
  return esDiaPosterior(primeraData, dataActual);
};

export const esAnteriorDesdeDataActual = (data, quantitat, unitat) => {
  const dataLimit = moment().subtract(quantitat, unitat);
  return data.isBefore(dataLimit);
};

export const esAnteriorDesdeDataActualSinHora = (data, quantitat, unitat) => {
  const dataLimit = moment()
    .subtract(quantitat, unitat)
    .startOf("day");
  return data.isBefore(dataLimit);
};

export const esDiaAnterior = (primeraData, segonaData) => {
  if (!primeraData) {
    return false;
  }
  return primeraData.isBefore(segonaData, "day");
};

export const esDiaPosterior = (primeraData, segonaData) => {
  if (!primeraData) {
    return false;
  }
  return primeraData.isAfter(segonaData, "day");
};

export const dataActual = () => moment();

export const textAMoment = (dataText, mascara) => moment(dataText, mascara);

export const formatStringDate = (dataText, mascara) =>
  moment(new Date(dataText)).format(mascara);

/**
 * Crea un objecte moment a partir d'un string. Si el string no te el formate 'YYYY-MM-DDTHH:mmZ', es pot especificar una mascara
 * per la creació.
 *
 * @param dataAstext
 * @param mascara
 * @return {Moment}
 */
export const convertirTextAMomentUTC = (
  dataAsText,
  mascara = MASCARA_ISO_HHMM_Z
) => {
  var dateMoment = moment.utc(dataAsText, mascara, true);

  if (!dateMoment.isValid()) {
    //TODO: tractar error al crear una data invalida
    console.error("Data invàlida. Valor:", dataAsText);
    return null;
  }

  return dateMoment;
};

/**
 * Crea un objecte {Moment} a partir d'un string. Si el string no té el format 'YYYY-MM-DDTHH:mmZ',
 * es pot especificar una màscara per la creació.
 *
 * @param dataAstext
 * @param mascara
 * @return {Moment}
 */
export const convertirTextAMomentLocal = (
  dataText,
  mascara = MASCARA_ISO_HHMM_Z
) => {
  var data = moment(dataText, mascara, true);

  if (!data.isValid()) {
    //TODO: tractar error al crear una data invàlida
    console.error("Data invàlida. Valor:", dataText);
    return null;
  }

  return data;
};

/**
 *
 * @param {moment} dataCalendari
 * @param {moment} dataActual
 * @param {string} granuralitat
 */
export const esDataValidaSelectorObservacions = (
  dataCalendari,
  dataActual,
  granuralitat,
  isAdmin
) => {
  const dataPassatNoMostrarSelectorObservacions = isAdmin
    ? DATA_PASSAT_NO_MOSTRAR_SELECTOR_OBSERVACIONS_ADMIN
    : DATA_PASSAT_NO_MOSTRAR_SELECTOR_OBSERVACIONS;

  if (
    !dataCalendari ||
    !dataActual ||
    !dataPassatNoMostrarSelectorObservacions
  ) {
    return false;
  }

  const esDataFutura = dataCalendari.isAfter(dataActual, granuralitat);
  const esDataAnteriorADataFi = dataCalendari.isBefore(
    dataPassatNoMostrarSelectorObservacions,
    granuralitat
  );

  return esDataFutura || esDataAnteriorADataFi;
};

/**
 * Crea un objecte {array} de dates en format partir de una data d'inici i una data de fi.
 *
 * @param dataInici
 * @param dataFi
 * @return {array}
 */
export const diasEntreDates = function(dataInici, dataFi, mascara) {
  let dates = [];
  let currDate = moment(dataInici).startOf("day");
  let lastDate = moment(dataFi).startOf("day");

  dates.push(currDate.format(mascara));

  while (currDate.add(1, "days").diff(lastDate) < 0) {
    dates.push(currDate.format(mascara));
  }
  if (dataInici !== dataFi) {
    dates.push(lastDate.format(mascara));
  }

  return dates;
};
